module.exports = __webpack_public_path__ + "static/media/A3.fdc5e976.mp3";